<script setup lang="ts">
import LocalLoader from "@/components/ui/loaders/LocalLoader.vue";

interface Props {
  position?: "fixed" | "absolute";
  backdropFilter?: string;
}

const props = withDefaults(defineProps<Props>(), {
  position: "fixed",
  backdropFilter: "2"
});
</script>

<template>
  <div
    class="global-loader"
    :class="`global-loader--${props.position}`"
    :style="{ backdropFilter: `blur(${props.backdropFilter}px)` }"
  >
    <LocalLoader />
  </div>
</template>

<style scoped lang="scss">
.global-loader {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;

  &--fixed {
    position: fixed;
  }

  &--absolute {
    position: absolute;
  }
}
</style>